export default {"src":"/_next/static/media/footer-logo.603551ce.svg","height":22,"width":157,"blurWidth":0,"blurHeight":0};